<template>
    <div class="shareCar">
       <share-car-search></share-car-search>
       <share-car-container></share-car-container>
    </div>
</template>
<script>
import ShareCarSearch from '@/components/shareCar/Search.vue'
import ShareCarContainer from '@/components/shareCar/Container.vue'
export default {
  name: 'shareCar',
  components: {
    ShareCarSearch,
    ShareCarContainer
  }
}
</script>
<style lang="stylus">
  .shareCar
    padding 20px
    height calc(100% - 40px)
</style>
